module.exports = __webpack_public_path__ + "img/carNoAct.cf5eb1a5.png";